import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrThemeSwitchComponent } from './pr-theme-switch.component';
import { PrButtonSwitchModule } from '../pr-button/pr-button-switch/pr-button-switch.module';

@NgModule({
  declarations: [PrThemeSwitchComponent],
  imports: [
    CommonModule,
    PrIconModule,
    MatSlideToggleModule,
    PrButtonSwitchModule,
  ],
  exports: [PrThemeSwitchComponent],
})
export class PrThemeSwitchModule {}
